import {container} from "@intelingu/core/IoC/container";
import {HttpClient} from "@intelingu/core/configs/axios.config";
import {UserApi} from "@intelingu/core/api/UserApi";
import {ILocalStorageAdapter, LocalStorageSymbol} from "@intelingu/core/stores/adapters/ILocalStorageAdapter";
import {LocalStorageAdapter} from "../stores/adapters/LocalStorageAdapter";
import {FormStore} from "@intelingu/core/stores/FormStore";
import {AuthStore} from "../stores/AuthStore";
import {WorkspaceStore} from "../stores/WorkspaceStore";

container.bind<ILocalStorageAdapter>(LocalStorageSymbol).to(LocalStorageAdapter).inSingletonScope();
container.bind<HttpClient>(HttpClient).toSelf().inSingletonScope();
container.bind<FormStore>(FormStore).toSelf().inRequestScope();
container.bind<AuthStore>(AuthStore).toSelf().inSingletonScope();
container.bind<WorkspaceStore>(WorkspaceStore).toSelf().inSingletonScope();

container.bind<UserApi>(UserApi).toSelf().inSingletonScope();
